import React, { useRef, useEffect, useState } from 'react'
import { motion } from 'framer-motion'
import Box from '@mui/material/Box'
import Avatar from '@mui/material/Avatar'
import { selectData } from 'layouts/onboarding'

const logos = selectData.giftCards

const ScrollingLogos = () => {
  const containerRef = useRef(null)
  const [scrollWidth, setScrollWidth] = useState(0)

  useEffect(() => {
    if (containerRef.current) {
      setScrollWidth(containerRef.current.scrollWidth / 2) // one set of logos
    }
  }, [])

  const duplicatedLogos = [...logos, ...logos]

  return (
    <Box
      my={3}
      sx={{
        position: 'relative',
        overflow: 'hidden',
        width: '100%',
        backgroundColor: '#f5f5f5',
        py: 1,
        borderRadius: '9999px',
      }}
    >
      <motion.div
        ref={containerRef}
        style={{
          display: 'flex',
          gap: '24px',
          whiteSpace: 'nowrap',
        }}
        animate={{ x: scrollWidth ? [0, -scrollWidth] : 0 }}
        transition={{
          x: {
            repeat: Infinity,
            repeatType: 'loop',
            duration: 20,
            ease: 'linear',
          },
        }}
      >
        {duplicatedLogos.map((item, index) => (
          <Avatar
            key={index}
            src={item.logo}
            alt={item.alt}
            sx={{ width: 40, height: 40 }}
            variant="circular"
          />
        ))}
      </motion.div>
    </Box>
  )
}

export default ScrollingLogos
